/*
 * Flags in public/flags, named by ISO 3166-1 alpha-2 code (lower case).
 *
 * Source: https://flagpedia.net/download/vector (SVG package, 254 flags),
 * downloaded 2026-10-27. Public domain, free for commercial use; a link
 * back to flagpedia.net is appreciated but not required.
 *
 * To update: download the SVG package again and replace the files in
 * public/flags. Ascension (ac) and Tristan da Cunha (ta) are not in the
 * package; PhoneInput keeps the flags mui-tel-input embeds for them.
 */

// public/flags is served from the site root in dev, and alongside the built
// assets once built (mirrors how `renderBuiltUrl` in vite.config.js prefixes
// asset URLs with VITE_BUILD_URL, which a runtime path does not get).
const FLAGS_URL = import.meta.env.VITE_BUILD_URL
  ? `${import.meta.env.VITE_BUILD_URL}dist/flags/`
  : '/flags/';

/** URL of the flag of a country by its ISO 3166-1 alpha-2 code. */
export function flagUrl(isoCode: string): string {
  return `${FLAGS_URL}${isoCode.toLowerCase()}.svg`;
}
